<span class="wip-wrapper">
    <img src="../../../assets/images/wip.svg" alt="work in progress">
    <a [hidden]="pageType==='home'" [routerLink]="['/home']">Click here to navigate to Home</a>
</span>
